export default {"src":"/_next/static/media/clipboardWithCross_40.f9a994fe.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};